// extracted by mini-css-extract-plugin
module.exports = {"sharedStyles":"\"../../themes/sharedStyles.module.css\"","title":"Title_title__1jlrO sharedStyles_standardTextStructure__2HVr-"};